const faqs = [
  {
    q: '6080新视觉影院真的完全免费吗？需要注册吗？',
    a: '是的，6080新视觉影院所有电视剧资源均免费在线观看，无需注册、无需登录、无需付费。打开网站即可直接搜索和观看任意剧集，真正做到零门槛追剧。',
  },
  {
    q: '播放画质怎么样？支持高清和1080P吗？',
    a: '平台支持1080P超清画质播放，部分热门剧集提供4K选项。采用H.265高效编码技术，在保证高清画质的同时大幅降低带宽占用，主流网络环境均可流畅观看。',
  },
  {
    q: '更新速度快吗？首播剧什么时候上线？',
    a: '编辑团队全天候监控各平台首播排期，热门剧集通常在电视台或流媒体平台播出后数小时内即可同步上线。每日更新动态可在更新专区查看最新上线内容。',
  },
  {
    q: '手机可以看吗？需要下载APP吗？',
    a: '6080新视觉影院全面适配手机、平板和电脑端，无需下载任何客户端或APP。直接在浏览器中打开网址即可享受与电脑端一致的高清流畅观影体验。',
  },
  {
    q: '剧集资源覆盖哪些类型？有海外剧吗？',
    a: '平台收录超过20000部剧集，覆盖国产剧、港台剧、韩剧、美剧、日剧、泰剧等全品类。无论热门IP改编还是小众口碑佳作，进口剧到国产经典一应俱全。',
  },
  {
    q: '播放卡顿怎么办？能切换线路吗？',
    a: '平台采用多线CDN智能加速，自动匹配最优播放节点。如遇卡顿，可尝试切换清晰度或等待自动缓冲。建议在网络稳定环境下观看以获得最佳体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-question-answer-line text-secondary-500 text-sm"></i>
            <span className="text-secondary-400 text-xs font-medium">常见问题</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">追剧常见问答</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            关于使用6080新视觉影院最常见的六个问题，帮你快速了解平台
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/60 rounded-xl p-5 hover:border-primary-500/15 transition-colors"
            >
              <h3 className="text-foreground-800 font-heading font-bold text-sm mb-2 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-500/15 flex-shrink-0 mt-0.5">
                  <i className="ri-question-mark text-primary-500 text-xs font-bold"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}